import * as lodash from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  ApiFavoriteDataGet,
  ApiFavoriteDelete,
  ApiFavoriteFolderListGet,
  ApiFavoriteGet,
} from '../../../api/front/favorite/api-favorite';
import {
  ApiSetFavoriteListGet,
  ApiSetFavoriteGet,
  ApiSetFavoriteCreate,
  ApiSetFavoriteUpdate,
  ApiSetFavoriteDelete,
} from '../../../api/front/favorite-set/api-favorite-set';
import { ResponseBase } from '../../../api/response-base';
import { useAppSelector } from '../../../app/hooks';
import folderClose from '../../../assets/img/icon/folder-close-black.svg';
import folderOpen from '../../../assets/img/icon/folder-open-black.svg';
import {
  FavoriteGetFolderResponse,
  FavoriteGetResponse, FavoriteProductListItem,
} from '../../../models/api/front/favorite';
import {
  SetFavoriteItemResponse,
  SetFavoriteItemListResponse, SetFavoriteItemRequest,
} from '../../../models/api/front/favorite-set';
import { apiActions } from '../../../slices/api-slice';
import { FavoriteBrand, favoriteBrandActions, FavoriteBrandItem } from '../../../slices/favorite-brand-slice';
import { toolbarActions } from '../../toolbar/slice/toolbar-slice';
import { Button } from '../../ui/button/button';
import { SwitchIcon } from '../../ui/switch-icon/switch-icon';
import { dialogActions } from '../slice/dialog-slice';
import { AddFolder } from './add-folder';
import { ChangeFavoriteBrandName } from './change-favorite-brand-name';
import './favorite-selector-config.scss';
import { ApiFavoriteFolderDelete, ApiFavoriteFolderPost } from '../../../api/front/favorite-folder/api-favorite-folder';
import { FavoriteFolderListItem } from '../../../models/api/front/favorite-folder';
import { FavoriteTemplateItem } from '../../../slices/favorite-template-slice';
import { Input } from '../../ui/input/input';
import { LoadingPopup } from '../../ui/loading/loading-popup';
import { folder } from 'jszip';

const getChildrenName = (content: FavoriteBrandItem) => {
  let str = content.name;
  content.children.forEach((v) => {
    str += v.name;
    v.children.forEach((c) => {
      str += getChildrenName(c);
    })
  });
  return str;
};

type ChangeFolderNameProps = {
  kijshopCd: string,
  // - 更新するフォルダ -
  targetFolder: FavoriteTemplateItem,
  level?: number,
  usedNameList?: string[],
  parentId?: string,
  indexes?: number,
  callback?: {
    onSuccess: () => void,
    onError: () => void,
  },
}

type ChildContentProps = {
  kijshopCd: string,
  // - ひとつの表示項目 -
  content: FavoriteBrandItem,
  // - 下位層のインデント -
  layerIndent?: number,
  // - 層の深度 -
  layerDepth?: number
  // - 下位層なしアイテム用インデント(ツリーアイコン幅) -
  noChildIndent?: number,
  // - ツリーアイコン幅設定用コールバック(値の共有用) -
  setTreeIconWidth?: (width: number) => void,
  // - お気に入り商品保存ダイアログか -
  isSaveDialog?: boolean,
  // - 識別用ID -
  id?: string,
  // - 選択中IDの設定 -
  callbackSelectedContentID?: (id: string) => void,
  selected?: boolean,
  selectedId?: string,
  // callbackGetData?: (content: FavoriteBrandItem) => void,
  callbackChangeOpenCount: (num: number) => void,
  callbackCreateData: () => void,
  folderList: FavoriteFolderListItem[],
  favoriteDataList: FavoriteBrandItem[],
  parentId?: string,
  openFolders: string[],
  openOperation: (id: string, operate: 'open' | 'close') => void,
  isChecked?: (id: string) => boolean;                 // 状態を読む
  onRowCheck?: (brand: FavoriteBrand, checked: boolean) => void; // 状態を更新
};

// - １項目分の表示 -
const ChildContent = (props: ChildContentProps) => {
  const {
    kijshopCd,
    content: _content,
    layerIndent,
    layerDepth = 0,
    setTreeIconWidth,
    noChildIndent,
    id,
    callbackSelectedContentID,
    selected: _selected,
    selectedId: _selectedId,
    callbackChangeOpenCount,
    callbackCreateData,
    folderList,
    favoriteDataList,
    parentId,
    openFolders,
    openOperation,
    isChecked,
    onRowCheck,
  } = props;
  const dispatch = useDispatch();
  const treeIconWidth = noChildIndent;

  // - State -
  // -- 第2階層以下表示の有無 --
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(_content);

  // - Ref -
  // -- ツリー構造用アイコンEle --
  const treeIconEle = useRef<HTMLDivElement>(null);
  // -- フォルダーアイコンEle --
  const folderIconEle = useRef<HTMLDivElement>(null);
  const [selectedId, setSelectedId] = useState(_selectedId);
  useEffect(() => {
    if (selectedId !== _selectedId) {
      setSelectedId(_selectedId);
    }
  }, [_selectedId]);
  const [selected, setSelected] = useState(_selected);
  useEffect(() => {
    if (selected !== _selected) {
      setSelected(_selected);
    }
  }, [_selected]);
  const [dataList, setDataList] = useState<FavoriteBrandItem[]>(content.children);
  useEffect(() => {
    if (dataList.length !== content.children.length) {
      setDataList(content.children);
    }
    if (!isOpen && content.children.find((v) => v.id === selectedId)) {
      setIsOpen(true);
    }
  }, [content]);
  useEffect(() => {
    if (content.type === 'folder' && openFolders.find((v) => v === content.id)) {
      setIsOpen(true);
    }
  },[]);

  // - Callback -
  // -- フォルダ押下 --
  const handlerClickContent = useCallback((selectId) => {
    callbackSelectedContentID && callbackSelectedContentID(selectId || '');
    dispatch(favoriteBrandActions.setSelectBrand({ ...content, level: (content.type === 'folder') ? layerDepth : layerDepth - 1, parentId: parentId || '' }));
    //フォルダと商品で行クリック時の動作を分ける
    if(content.type === 'folder') { // フォルダの時
      setIsOpen (prev => {
        const next = !prev;
        openOperation(content.id, next? 'open' : 'close');
        return next
      });
    } else if (content.type === 'brand') { // お気に入り商品の時
      const idStr = String(content.id);
      const nextChecked = !Boolean(isChecked?.(idStr));
      onRowCheck?.({id: idStr, name: content.name}, nextChecked);
    }
  }, [content, callbackSelectedContentID, layerDepth, parentId, openOperation, isChecked, onRowCheck, dispatch]);

  const handlerChangeOpenCount = useCallback((v) => {
    callbackChangeOpenCount(v + (isOpen ? dataList.length : 0));
  }, [callbackChangeOpenCount, dataList.length]);

  // -- アイコン幅 --
  useEffect(() => {
    const tiw = treeIconEle.current?.getBoundingClientRect().width || 0;
    if (tiw && tiw !== treeIconWidth) {
      setTreeIconWidth && setTreeIconWidth(tiw);
    }
  }, []);

  useEffect(() => {
    if (id && content.name && content.type === 'folder') {
      dispatch(apiActions.run(
        new ApiFavoriteGet({ kijshopCd, folederId: id }),
        {
          onSuccess: (res: ResponseBase<FavoriteGetResponse>) => {
            setDataList((prev) => [...prev, ...[...(res.body.data?.favProductList || [])].sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1).filter((v) => !prev.find((fav) => fav.id === v.favProductId)).map((v) => ({
              id: v.favProductId,
              name: v.name,
              type: 'brand',
              children: [] as FavoriteBrandItem[],
            }))] as FavoriteBrandItem[]);
            setContent((prev) => ({
              ...prev,
              children: [
                ...prev.children,
                ...[...(res.body.data?.favProductList || [])].sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1).filter((v) => !prev.children.find((fav) => fav.id === v.favProductId)).map((v) => ({
                  id: v.favProductId,
                  name: v.name,
                  type: 'brand',
                  children: [] as FavoriteBrandItem[],
                })),
              ] as FavoriteBrandItem[],
            }));
          },
        },
      ));
    }
  }, [id]);

  useEffect(() => {
    callbackChangeOpenCount(isOpen ? dataList.length : 0);
  }, [isOpen, dataList.length]);
  return (
    <>
      <div
        className={`favorite_brand_config__table__body__row${content.id === selectedId ? ' selected' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handlerClickContent(content.id);
        }}
        style={{ ...layerIndent ? { paddingLeft: `calc(${layerIndent * layerDepth}px + 0.5em)` } : {} }}
      >
        <div className="favorite_brand_config__table__body__row__icon" style={content.children.length ? {} : { paddingLeft: noChildIndent }}>
          {content.children.length ? (
            <SwitchIcon isOn={isOpen} tmplMode="tree" ref={treeIconEle} />
          ) : (<></>)}
          {content.name && content.type === 'folder' ? (
            <SwitchIcon
              isOn={isOpen}
              tmplMode="folder"
              ref={folderIconEle}
              switchEle={{ on: <img src={folderOpen} alt="" />, off: <img src={folderClose} alt="" /> }}
            />
          ) : (<></>)}
        </div>

        {/* お気に入り商品の行にチェックボックスを出す処理 */}
        {content.type === 'brand' && content.id ? (
          <div className="favorite_brand_config__table__body__row__checkbox">
            <input
              type="checkbox"
              checked={Boolean(isChecked?.(String(content.id)))}
              onChange={(e) => onRowCheck?.({ id: content.id, name: content.name }, e.target.checked)}
              onClick={(e) => e.stopPropagation()}
              aria-label="商品を選択"
            />
          </div>
        ) : (
          // カラムの位置合わせ用。不要なら削ってOK
          <div className="favorite_brand_config__table__body__row__checkbox placeholder" />
        )}

        <div className="favorite_brand_config__table__body__row__data">{content.name.replaceAll(' ', '\u00A0')}</div>
      </div>
      {isOpen ?
        // content.children.map((v, i) => <ChildContent
        //   kijshopCd={kijshopCd}
        //   key={`favorite-brand-config_${i}_${v.id}`}
        //   id={String(v.id)}
        //   content={v} layerIndent={treeIconWidth}
        //   layerDepth={layerDepth + 1}
        //   noChildIndent={noChildIndent}
        //   // 階層構造なしにつき選択中(selected)props未設定
        // />)
        dataList.map((v, i) => <ChildContent
          kijshopCd={kijshopCd}
          key={`favorite-brand-config_${i}_${v.id}_${v.name}_${getChildrenName(v)}`}
          id={String(v.id)}
          content={v}
          layerIndent={treeIconWidth}
          layerDepth={layerDepth + 1}
          noChildIndent={noChildIndent}
          callbackSelectedContentID={(v) => {
            callbackSelectedContentID?.(v);
          }}
          selected={selectedId === v.id}
          selectedId={selectedId}
          callbackChangeOpenCount={handlerChangeOpenCount}
          callbackCreateData={callbackCreateData}
          folderList={folderList}
          favoriteDataList={favoriteDataList}
          parentId={id}
          openFolders={openFolders}
          openOperation={openOperation}
          isChecked={isChecked}
          onRowCheck={onRowCheck}
        />)
        : (<></>)}
    </>
  );
};

type FavoriteSelectorConfigProps = {
  kijshopCd: string,
  // - 閉じるボタンの表示名 -
  closeButtonLabel?: string,
  // - 閉じるボタンcallback -
  closeButtonCallback?: () => void,
  // - OKボタンcallback -
  okButtonCallback?: () => void,
  // - お気に入り商品保存ダイアログか -
  isSaveDialog?: boolean,
  // - OKボタン押下フラグ -
  disabled?: boolean,
  // - 編集時用の項目を追加
  mode?: 'create' | 'edit' | 'draft';
  initialSetId?: string; // edit時のみ
  setName?: string;
};
export const FavoriteSelectorConfig = (props: FavoriteSelectorConfigProps) => {
  const { kijshopCd, closeButtonLabel, closeButtonCallback, okButtonCallback, isSaveDialog, disabled: _disabled, setName } = props;
  // - Hooks -
  const dispatch = useDispatch();
  const { brandList, selectBrand, brandDataList, activeBrands } = useAppSelector((state) => ({
    brandList: state.favoriteBrand.brandList,
    selectBrand: state.favoriteBrand.selectBrand,
    brandDataList: state.favoriteBrand.brandDataList,
    activeBrands: state.favoriteBrand.activeFavoriteBrands,
  }), lodash.isEqual);

  // - State -
  const [treeIconWidth, setTreeIconWidth] = useState(0);
  const [selectedId, setSelectedId] = useState('');
  const [folderList, setFolderList] = useState<FavoriteFolderListItem[]>([]);
  const [favoriteDataList, setFavoriteDataList] = useState<FavoriteBrandItem[]>([]);
  const [disabled, setDisabled] = useState(_disabled);
  const [childrenOpenCountArr, setChildrenOpenCountArr] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingInit, setLoadingInit] = useState(true);
  const [checkedFavoriteBrands, setCheckedFavoriteBrands] = useState<FavoriteBrand[]>(activeBrands);// 選択商品のIDと名前を配列で管理
  const [inputName, setInputName] = useState(setName ?? ''); // セット登録の名称を管理

  useEffect(() => {
    setDisabled(_disabled);
  }, [_disabled]);

  // - Callback -
  // -- 閉じるボタン押下 --
  const handlerClickClose = useCallback(() => {
    dispatch(dialogActions.pop());
    dispatch(favoriteBrandActions.setSelectBrand(undefined));
  }, []);

  // -- お気に入り商品フォルダ一覧取得 --
  const handlerCreateListData = useCallback((content?: FavoriteBrandItem) => {
    setLoading(true);
    dispatch(apiActions.run(
      new ApiFavoriteFolderListGet({ kijshopCd }),
      {
        onSuccess: async (res: ResponseBase<FavoriteGetFolderResponse>) => {
          // setFolderList(res.body.data?.folderList || []);
          const data = [...(res.body.data?.folderList || [])].sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
          setFolderList([...data]);
          const arr: FavoriteBrandItem[] = [];
          const findParent = (child: FavoriteFolderListItem, parentArr: FavoriteBrandItem[]) => {
            let flag = false;
            const parent = parentArr.find((v) => v.id === child.parentId);
            if (parent && !parent.children.find((v) => v.id === child.folderId)) {
              flag = true;
              parent.children.push({
                id: child.folderId,
                name: child.name,
                type: 'folder',
                level: child.level,
                parentId: parent.id,
                children: [],
              });
            } else {
              parentArr.forEach((v) => {
                flag = flag || findParent(child, v.children);
              });
            }
            return flag;
          };
          let len = data.length;
          const childArr: FavoriteBrandItem[] = [];
          while (data.length) {
            data.forEach((v) => {
              if (!v.parentId) {
                arr.push({
                  id: v.folderId,
                  name: v.name,
                  type: 'folder',
                  level: v.level,
                  parentId: '',
                  children: [],
                });
              } else {
                if (findParent(v, arr)) {
                  childArr.push({
                    id: v.folderId,
                    name: v.name,
                    type: 'folder',
                    level: v.level,
                    parentId: '',
                    children: [],
                  });
                }
              }
            });
            arr.forEach((v) => {
              const index = data.findIndex((d) => d.folderId === v.id);
              if (index !== -1) {
                data.splice(index, 1);
              }
            });
            childArr.forEach((v) => {
              const index = data.findIndex((d) => d.folderId === v.id);
              if (index !== -1) {
                data.splice(index, 1);
              }
            });
            // data.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
            if (len === data.length) {
              break;
            }
            len = data.length;
          }
          // arr.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
          setFavoriteDataList(lodash.cloneDeep(arr));
          let cnt = arr.length;
          const loadingEnd = () => {
            cnt--;
            if (cnt < 1) {
              setLoading(false);
              setLoadingInit(false);
            }
          };
          arr.forEach((v) => {
            dispatch(apiActions.run(
              new ApiFavoriteGet({ kijshopCd, folederId: v.id }),
              {
                onSuccess: (res: ResponseBase<FavoriteGetResponse>) => {
                  loadingEnd();
                  if (res.body.data?.favProductList?.[0]) {
                    setFavoriteDataList((prev) => {
                      const list = [...prev].sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
                      const dataIndex = list.findIndex((p) => p.id === v.id);
                      if (dataIndex !== -1) {
                        const data = lodash.cloneDeep(list[dataIndex]);
                        const arr = [...(res.body.data?.favProductList || [])].sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
                        arr.forEach((v) => {
                          if (!data.children.find((c) => c.id === v.favProductId)) {
                            data.children.push({
                              id: v.favProductId,
                              name: v.name,
                              type: 'brand',
                              level: v.level,
                              parentId: data.id,
                              children: [],
                            } as FavoriteBrandItem);
                          }
                        });
                        // data.children.sort((a, b) => (a.type === 'folder' && a.type !== b.type ? 1 : (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)))
                        list[dataIndex] = data;
                      }
                      return list;
                    });
                  }
                },
                onError: loadingEnd,
              },
            ));
          });
        },
        onError: () => {
          setLoading(false);
        },
      },
    ));
  }, []);

  const handlerChangeOpenCount = useCallback((v, i) => {
    const arr = [...childrenOpenCountArr];
    arr[i] = v;
    setChildrenOpenCountArr(arr);
  }, [childrenOpenCountArr]);
  // - Effect -
  // 編集モード時のセット1件を取得して初期値を反映
  useEffect(() => {
    if (props.mode !== 'edit' || !props.initialSetId) return;

    dispatch(
      apiActions.run(
        new ApiSetFavoriteGet(props.initialSetId, { kijshopCd: props.kijshopCd }),
        {
          onSuccess: (res: ResponseBase<SetFavoriteItemResponse>) => {
            const d = res.body.data;
            // セット名を反映
            setInputName(d?.name ?? '');
            // チェック済み商品を反映
            setCheckedFavoriteBrands(d?.favProducts ?? []);
            setLoadingInit(false);
          },
          onError: () => {
            setLoadingInit(false);
            dispatch(dialogActions.pushMessage({
              title: '確認',
              message: [
                'セット情報の取得に失敗しました'
              ],
              buttons: [
                {
                  label: 'OK',
                  callback: () => dispatch(dialogActions.pop()),
                },
              ],
            }));
          },
        },
        { apiName: `favoriteSet:get:${props.initialSetId}` } // 連打対策（最新のみ採用）
      )
    );
  }, [dispatch, props.mode, props.initialSetId, props.kijshopCd]);
  // ツリーの描画処理
  useEffect(() => {
    handlerCreateListData();
  }, []);

  const totalCount = (() => {
    let num = 0;
    childrenOpenCountArr.forEach((v) => {
      num += v || 0;
    });
    return num + favoriteDataList.length;
  })();

  // フォルダの開閉状態を保存
  const [openFolders, setOpenFolders] = useState<string[]>([]);
  const openOperation = (id: string ,operate: 'open' | 'close') => {
    if (operate === 'open') {
      setOpenFolders([...openFolders,id]);
    } else {
      const arr = openFolders.filter((v) => v !== id);
      setOpenFolders([...arr]);
    }
  }

  // チェック状態の管理
  // 1行のチェック切り替え処理
  const handleRowCheck = useCallback((brand: FavoriteBrand, checked: boolean) => {
    setCheckedFavoriteBrands(prev => {
      if (checked) {
        if (prev.some(v => v.id === brand.id)) return prev;
        return [...prev, brand];
      } else {
        return prev.filter(v => v.id !== brand.id);
      }
    });
  }, []);

  const isChecked = useCallback((id: string) => {
    return checkedFavoriteBrands.some(v => v.id === id);
  }, [checkedFavoriteBrands]);

  // 選択済みデータを取り出す
  const collectCheckedItems = useCallback(() => {
    return checkedFavoriteBrands.map(v => v.id);
  }, [checkedFavoriteBrands]);

  // お気に入り商品のセット登録処理
  const handlerClickSetCreate = useCallback(() => {
    // セット登録名の取得
    const name = inputName.trim();
    if (!name) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          'セット名を入力してください'
        ],
        buttons: [
          {
            label: 'OK',
            callback: () => dispatch(dialogActions.pop()),
          },
        ],
      }));
      return;
    }
    // 選択されたお気に入り商品のidを取得して、配列にまとめる
    const favProductIds = collectCheckedItems();
    // APIの登録処理
    setLoading(true);
    const payload = {kijshopCd: props.kijshopCd, name, favProductIds};
      dispatch(apiActions.run(
        new ApiSetFavoriteCreate (payload),
        {
          onSuccess: (res: ResponseBase<SetFavoriteItemResponse>) => {
            setLoading(false);
            setLoadingInit(false);
            props.okButtonCallback?.();    // セット一覧画面の更新と選択画面のダイヤログを閉じる
          },
            onBasicError: () => {
              setLoading(false);
              setLoadingInit(false);
              dispatch(dialogActions.pushMessage({
                title: '確認',
                message: [
                  '入力エラーです。内容を確認してください。'
                ],
                buttons: [
                  {
                    label: 'OK',
                    callback: () => dispatch(dialogActions.pop()),
                  },
                ],
              }));
          },
          onError: () => {
            setLoading(false);
            setLoadingInit(false);
            dispatch(dialogActions.pushMessage({
              title: '確認',
              message: [
                '登録に失敗しました。時間をおいて再度お試しください。'
              ],
              buttons: [
                {
                  label: 'OK',
                  callback: () => dispatch(dialogActions.pop()),
                },
              ],
            }));
          },
        },
        { apiName: 'favoriteSet:create' } // 最新だけ採用
      ))
  }, [dispatch, kijshopCd, inputName, collectCheckedItems]);

  // 編集時の処理
  const handlerClickSetUpdate = useCallback(() => {
    if (props.mode !== 'edit' || !props.initialSetId) return;

    // セット登録名の取得
    const name = inputName.trim();
    if (!name) {
      dispatch(dialogActions.pushMessage({
        title: '確認',
        message: [
          'セット名を入力してください'
        ],
        buttons: [
          {
            label: 'OK',
            callback: () => dispatch(dialogActions.pop()),
          },
        ],
      }));
      return;
    }
    // 選択されたお気に入り商品のidを取得して、配列にまとめる
    const favProductIds = collectCheckedItems();
    // APIの編集処理
    setLoading(true);
    dispatch(apiActions.run(
      new ApiSetFavoriteUpdate(
        props.initialSetId,
        { kijshopCd: props.kijshopCd, name, favProductIds }
      ),
      {
        onSuccess: () => {
          setLoading(false);
          setLoadingInit(false);
          props.okButtonCallback?.();    // セット一覧画面の更新と選択画面のダイヤログを閉じる
        },
        onBasicError: () => {
          setLoading(false);
          setLoadingInit(false);
          dispatch(dialogActions.pushMessage({
            title: '確認',
            message: [
              '入力エラーです。内容を確認してください。'
            ],
            buttons: [
              {
                label: 'OK',
                callback: () => dispatch(dialogActions.pop()),
              },
            ],
          }));
        },
        onError: () => {
          setLoading(false);
          setLoadingInit(false);
          dispatch(dialogActions.pushMessage({
            title: '確認',
            message: [
              '登録に失敗しました。時間をおいて再度お試しください。'
            ],
            buttons: [
              {
                label: 'OK',
                callback: () => dispatch(dialogActions.pop()),
              },
            ],
          }));
        },
      },
      { apiName: `favoriteSet:update:${props.initialSetId}` }
    ));
  }, [dispatch, props.mode, props.initialSetId, props.kijshopCd, inputName, collectCheckedItems, handlerCreateListData]);

  // お気に入り商品セットに仮追加
  const handlerClickSetDraftAdd = useCallback(() => {
    if (props.mode !== 'draft') return;
    dispatch(favoriteBrandActions.setActiveFavoriteBrands(checkedFavoriteBrands));
    dispatch(dialogActions.pop());
  }, [checkedFavoriteBrands]);

  return (
    <div className="dialog_contents favorite_selector_config">
      <div className='favorite_selector_config__content'>登録することで、次回から簡単に呼び出せます。</div>
      <div className='favorite_selector_config__content'>お気に入りセット商品の名称を入力してください</div>
      <Input
        value={inputName}
        onChange={(e) => setInputName(e.target.value)}
        maxLength={40}
      />
      <div className='favorite_selector_config__content__warning'>※ 40文字以内で入力してください</div>
      <div className='favorite_selector_config__table_message'>セットにするお気に入り商品を選択してください</div>
      <div className="dialog_contents__body favorite_selector_config__table">
        <div className="favorite_selector_config__table__inner">
          <div className="favorite_selector_config__table__header">お気に入りセット商品保存</div>
          <div className="favorite_selector_config__table__body">
            {favoriteDataList.map((v, i) => (
              <ChildContent
                key={`favorite-selector-config_${i}_${v.id}_${v.name}_${getChildrenName(v)}_${loading}`}
                kijshopCd={kijshopCd}
                content={v}
                // id={`${i}_${v.id}`}
                id={String(v.id)}
                setTreeIconWidth={setTreeIconWidth}
                noChildIndent={treeIconWidth}
                isSaveDialog={isSaveDialog}
                callbackSelectedContentID={setSelectedId}
                selected={selectedId === v.id}
                selectedId={selectedId}
                // callbackGetData={handlerCreateListData}
                callbackChangeOpenCount={(num) => handlerChangeOpenCount(num, i)}
                callbackCreateData={handlerCreateListData}
                folderList={folderList}
                favoriteDataList={favoriteDataList}
                layerDepth={1}
                openFolders={openFolders}
                openOperation={openOperation}
                isChecked={isChecked}
                onRowCheck={handleRowCheck}
              />
            ))}
            {totalCount < 10 ? ([...new Array(10 - totalCount)].map((_, i) => (
              <ChildContent
                key={`favorite-selector-config_${i}_dummy`}
                kijshopCd={kijshopCd}
                content={{
                  id: '',
                  name: '',
                  type: 'brand',
                  level: 1,
                  parentId: '',
                  children: [],
                }}
                id={`${i}_dummy`}
                setTreeIconWidth={setTreeIconWidth}
                noChildIndent={treeIconWidth}
                isSaveDialog={isSaveDialog}
                callbackSelectedContentID={setSelectedId}
                selected={false}
                callbackChangeOpenCount={() => {}}
                callbackCreateData={handlerCreateListData}
                folderList={folderList}
                favoriteDataList={favoriteDataList}
                openFolders={openFolders}
                openOperation={openOperation}
                isChecked={isChecked}
                onRowCheck={handleRowCheck}
              />
            ))) : (<></>)}
          </div>
        </div>
      </div>
      <div className="dialog_contents__footer">
        <div className="dialog_contents__footer__left">
          <Button
            label={closeButtonLabel ? closeButtonLabel : 'キャンセル'}
            onClick={closeButtonCallback ? closeButtonCallback : handlerClickClose}
          />
        </div>
        <div className="dialog_contents__footer__right">
            <Button
              label="OK"
              onClick={props.mode === 'draft' ? handlerClickSetDraftAdd : props.mode === 'edit' ? handlerClickSetUpdate : handlerClickSetCreate}
              disabled={collectCheckedItems().length === 0 || disabled}
            />
        </div>
      </div>
      {loadingInit ? <LoadingPopup key={`fav-loading`} /> : <></>}
      {!loadingInit && loading ? <LoadingPopup key={`fav-loading`} label={'更新中です'} /> : <></>}
    </div>
  );
};
